import { IDataVesselCrewRoleResourceShortProps } from '../../../props/data/vessels/crew';
import Request from './../../request';

// import props

const DataVesselCrewRoleService = {
    retrieve: async (qs?: string): Promise<IDataVesselCrewRoleResourceShortProps[]> => {
        try {
            const results = await Request.get(`/api/data/vessels/crewroles?${qs || ""}`);
            return results;
        } catch (e) {
            throw (e);
        }
    }
};

export default DataVesselCrewRoleService;